import { ReactComponent as DiscordIcon } from '../../assets/icons/discord.svg';
import { ReactComponent as TwitterIcon } from '../../assets/icons/twitter.svg';
import { ReactComponent as MediumIcon } from '../../assets/icons/medium.svg';
import { ReactComponent as TelegramIcon } from '../../assets/icons/telegram.svg';
import { ReactComponent as RedditIcon } from '../../assets/icons/reddit.svg';


export const socialMediaLinks = [{
    icon: <TwitterIcon />,
    name: 'Twitter',
    link: 'https://x.com/nereusfinance'
}, {
    icon: <DiscordIcon />,
    name: 'Discord',
    link: 'https://discord.gg/AhD4BJHZD8'
}, {
    icon: <MediumIcon />,
    name: 'Medium',
    link: 'https://medium.com/nereus-protocol'
}, {
    icon: <TelegramIcon />,
    name: 'Telegram',
    link: 'https://t.me/nereusofficialgroup'
}, {
    icon: <RedditIcon />,
    name: 'Reddit',
    link: 'https://www.reddit.com/r/NereusFinanceWXT/'
}];